import { useWindowSize } from "@react-hook/window-size";
import { useMemo } from "react";
import { useHydrated } from "~/hooks/useHydrated";

const useBreakpoints = () => {
  const isHydrated = useHydrated();
  const [width] = useWindowSize({
    initialWidth: 0,
  });

  const isDesktop = useMemo(() => {
    return isHydrated && width >= 1100;
  }, [isHydrated, width]);

  const isTablet = useMemo(() => {
    return isHydrated && width >= 800 && width < 1100;
  }, [isHydrated, width]);

  const isMobile = useMemo(() => {
    return isHydrated && width < 800;
  }, [isHydrated, width]);

  return { isMobile, isTablet, isDesktop };
};

export default useBreakpoints;
